export type FrCalculatorCategory =
  | "Mathématiques et Algèbre"
  | "Notes et Éducation"
  | "Finance et Quotidien"
  | "Santé et Fitness"
  | "Unités et Physique"
  | "Conversion et Géométrie"
  | "Statistiques et Données"
  | "Ingénierie et Électronique"
  | "Chimie et Science"
  | "Affaires et Productivité";

export interface FrCalculatorMeta {
  slug: string;
  enSlug: string;
  name: string;
  tagline: string;
  description: string;
  category: FrCalculatorCategory;
  icon: string;
  featured?: boolean;
  keywords: string[];
}

export const FR_CALCULATOR_CATEGORIES: FrCalculatorCategory[] = [
  "Mathématiques et Algèbre",
  "Notes et Éducation",
  "Finance et Quotidien",
  "Santé et Fitness",
  "Unités et Physique",
  "Conversion et Géométrie",
  "Statistiques et Données",
  "Ingénierie et Électronique",
  "Chimie et Science",
  "Affaires et Productivité",
];

export const FR_CALCULATORS: FrCalculatorMeta[] = [
  {
    slug: "matrix-calculator",
    enSlug: "matrix-calculator",
    name: "Calculateur de Matrix",
    tagline: "Calculateur de Matrix gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Matrix. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Mathématiques et Algèbre",
    icon: "Grid",
    featured: true,
    keywords: ["calculateur de matrix","matrix calculator","matrix calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "logarithm-calculator",
    enSlug: "logarithm-calculator",
    name: "Calculateur de Logarithm & Exponential",
    tagline: "Calculateur de Logarithm & Exponential gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Logarithm & Exponential. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Mathématiques et Algèbre",
    icon: "Binary",
    featured: true,
    keywords: ["calculateur de logarithm & exponential","logarithm & exponential calculator","logarithm calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "lcm-gcd-calculator",
    enSlug: "lcm-gcd-calculator",
    name: "Calculateur de LCM & GCD (HCF)",
    tagline: "Calculateur de LCM & GCD (HCF) gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de LCM & GCD (HCF). Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Mathématiques et Algèbre",
    icon: "Hash",
    featured: true,
    keywords: ["calculateur de lcm & gcd (hcf)","lcm & gcd (hcf) calculator","lcm gcd calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "trigonometry-calculator",
    enSlug: "trigonometry-calculator",
    name: "Solveur de Trigonometry & Right Triangle",
    tagline: "Solveur de Trigonometry & Right Triangle gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Solveur de Trigonometry & Right Triangle. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Mathématiques et Algèbre",
    icon: "Compass",
    featured: true,
    keywords: ["solveur de trigonometry & right triangle","trigonometry & right triangle solver","trigonometry calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "sequence-calculator",
    enSlug: "sequence-calculator",
    name: "Calculateur de Sequence & Series (AP & GP)",
    tagline: "Calculateur de Sequence & Series (AP & GP) gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Sequence & Series (AP & GP). Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Mathématiques et Algèbre",
    icon: "ListOrdered",
    featured: true,
    keywords: ["calculateur de sequence & series (ap & gp)","sequence & series calculator (ap & gp)","sequence calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "percentage-calculator",
    enSlug: "percentage-calculator",
    name: "Calculateur de Percentage",
    tagline: "Calculateur de Percentage gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Percentage. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Mathématiques et Algèbre",
    icon: "Percent",
    featured: true,
    keywords: ["calculateur de percentage","percentage calculator","percentage calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "grade-calculator",
    enSlug: "grade-calculator",
    name: "Calculateur de Grade & GPA",
    tagline: "Calculateur de Grade & GPA gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Grade & GPA. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Notes et Éducation",
    icon: "GraduationCap",
    featured: true,
    keywords: ["calculateur de grade & gpa","grade & gpa calculator","grade calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "fraction-to-percent-calculator",
    enSlug: "fraction-to-percent-calculator",
    name: "Calculateur de Fraction to Percent",
    tagline: "Calculateur de Fraction to Percent gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Fraction to Percent. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Mathématiques et Algèbre",
    icon: "Binary",
    featured: true,
    keywords: ["calculateur de fraction to percent","fraction to percent calculator","fraction to percent calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "attendance-calculator",
    enSlug: "attendance-calculator",
    name: "Calculateur de Attendance Percentage",
    tagline: "Calculateur de Attendance Percentage gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Attendance Percentage. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Notes et Éducation",
    icon: "UserCheck",
    featured: true,
    keywords: ["calculateur de attendance percentage","attendance percentage calculator","attendance calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "discount-calculator",
    enSlug: "discount-calculator",
    name: "Calculateur de Discount & Sales Tax",
    tagline: "Calculateur de Discount & Sales Tax gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Discount & Sales Tax. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Finance et Quotidien",
    icon: "Tag",
    featured: true,
    keywords: ["calculateur de discount & sales tax","discount & sales tax calculator","discount calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "age-calculator",
    enSlug: "age-calculator",
    name: "Calculateur de Exact Age & Birthday",
    tagline: "Calculateur de Exact Age & Birthday gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Exact Age & Birthday. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Finance et Quotidien",
    icon: "Calendar",
    featured: true,
    keywords: ["calculateur de exact age & birthday","exact age & birthday calculator","age calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "ratio-calculator",
    enSlug: "ratio-calculator",
    name: "Calculateur de Ratio & Proportion",
    tagline: "Calculateur de Ratio & Proportion gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Ratio & Proportion. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Mathématiques et Algèbre",
    icon: "Scale",
    featured: true,
    keywords: ["calculateur de ratio & proportion","ratio & proportion calculator","ratio calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "average-calculator",
    enSlug: "average-calculator",
    name: "Calculateur de Average, Median & Mode",
    tagline: "Calculateur de Average, Median & Mode gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Average, Median & Mode. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Mathématiques et Algèbre",
    icon: "BarChart3",
    featured: true,
    keywords: ["calculateur de average, median & mode","average, median & mode calculator","average calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "tip-calculator",
    enSlug: "tip-calculator",
    name: "Calculateur de Tip & Bill Splitter",
    tagline: "Calculateur de Tip & Bill Splitter gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Tip & Bill Splitter. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Finance et Quotidien",
    icon: "Receipt",
    featured: true,
    keywords: ["calculateur de tip & bill splitter","tip & bill splitter calculator","tip calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "time-calculator",
    enSlug: "time-calculator",
    name: "Calculateur de Time & Work Hours",
    tagline: "Calculateur de Time & Work Hours gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Time & Work Hours. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Finance et Quotidien",
    icon: "Clock",
    featured: true,
    keywords: ["calculateur de time & work hours","time & work hours calculator","time calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "bmi-calculator",
    enSlug: "bmi-calculator",
    name: "Calculateur de BMI & Ideal Weight",
    tagline: "Calculateur de BMI & Ideal Weight gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de BMI & Ideal Weight. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Finance et Quotidien",
    icon: "HeartPulse",
    featured: true,
    keywords: ["calculateur de bmi & ideal weight","bmi & ideal weight calculator","bmi calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "interest-calculator",
    enSlug: "interest-calculator",
    name: "Calculateur de Simple & Compound Interest",
    tagline: "Calculateur de Simple & Compound Interest gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Simple & Compound Interest. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Finance et Quotidien",
    icon: "TrendingUp",
    featured: true,
    keywords: ["calculateur de simple & compound interest","simple & compound interest calculator","interest calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "cgpa-calculator",
    enSlug: "cgpa-calculator",
    name: "Calculateur de CGPA to Percentage",
    tagline: "Calculateur de CGPA to Percentage gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de CGPA to Percentage. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Notes et Éducation",
    icon: "Award",
    featured: true,
    keywords: ["calculateur de cgpa to percentage","cgpa to percentage calculator","cgpa calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "scientific-notation-calculator",
    enSlug: "scientific-notation-calculator",
    name: "Calculateur de Scientific Notation",
    tagline: "Calculateur de Scientific Notation gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Scientific Notation. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Mathématiques et Algèbre",
    icon: "Atom",
    featured: true,
    keywords: ["calculateur de scientific notation","scientific notation calculator","scientific notation calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "salary-calculator",
    enSlug: "salary-calculator",
    name: "Calculateur de Salary & Hourly Wage",
    tagline: "Calculateur de Salary & Hourly Wage gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Salary & Hourly Wage. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Finance et Quotidien",
    icon: "Wallet",
    featured: true,
    keywords: ["calculateur de salary & hourly wage","salary & hourly wage calculator","salary calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "gpa-target-calculator",
    enSlug: "gpa-target-calculator",
    name: "Calculateur de Target GPA",
    tagline: "Calculateur de Target GPA gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Target GPA. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Notes et Éducation",
    icon: "Target",
    featured: true,
    keywords: ["calculateur de target gpa","target gpa calculator","gpa target calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "loan-calculator",
    enSlug: "loan-calculator",
    name: "Calculateur de Loan Monthly Payment",
    tagline: "Calculateur de Loan Monthly Payment gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Loan Monthly Payment. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Finance et Quotidien",
    icon: "CreditCard",
    featured: true,
    keywords: ["calculateur de loan monthly payment","loan monthly payment calculator","loan calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "word-count-calculator",
    enSlug: "word-count-calculator",
    name: "Calculateur de Word & Character Count",
    tagline: "Calculateur de Word & Character Count gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Word & Character Count. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Notes et Éducation",
    icon: "FileText",
    featured: true,
    keywords: ["calculateur de word & character count","word & character count calculator","word count calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "gpa-to-percentage-calculator",
    enSlug: "gpa-to-percentage-calculator",
    name: "Convertisseur de GPA to Percentage",
    tagline: "Convertisseur de GPA to Percentage gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Convertisseur de GPA to Percentage. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Notes et Éducation",
    icon: "GraduationCap",
    featured: true,
    keywords: ["convertisseur de gpa to percentage","gpa to percentage converter","gpa to percentage calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "pythagorean-theorem-calculator",
    enSlug: "pythagorean-theorem-calculator",
    name: "Calculateur de Pythagorean Theorem",
    tagline: "Calculateur de Pythagorean Theorem gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Pythagorean Theorem. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Mathématiques et Algèbre",
    icon: "Triangle",
    featured: true,
    keywords: ["calculateur de pythagorean theorem","pythagorean theorem calculator","pythagorean theorem calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "quadratic-formula-calculator",
    enSlug: "quadratic-formula-calculator",
    name: "Solveur de Quadratic Equation",
    tagline: "Solveur de Quadratic Equation gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Solveur de Quadratic Equation. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Mathématiques et Algèbre",
    icon: "Variable",
    featured: true,
    keywords: ["solveur de quadratic equation","quadratic equation solver","quadratic formula calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "fuel-cost-calculator",
    enSlug: "fuel-cost-calculator",
    name: "Calculateur de Fuel Cost & Gas Mileage",
    tagline: "Calculateur de Fuel Cost & Gas Mileage gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Fuel Cost & Gas Mileage. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Finance et Quotidien",
    icon: "Fuel",
    featured: true,
    keywords: ["calculateur de fuel cost & gas mileage","fuel cost & gas mileage calculator","fuel cost calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "margin-calculator",
    enSlug: "margin-calculator",
    name: "Calculateur de Profit Margin & Markup",
    tagline: "Calculateur de Profit Margin & Markup gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Profit Margin & Markup. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Finance et Quotidien",
    icon: "DollarSign",
    featured: true,
    keywords: ["calculateur de profit margin & markup","profit margin & markup calculator","margin calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "pace-calculator",
    enSlug: "pace-calculator",
    name: "Calculateur de Running Pace & Speed",
    tagline: "Calculateur de Running Pace & Speed gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Running Pace & Speed. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Finance et Quotidien",
    icon: "Timer",
    featured: true,
    keywords: ["calculateur de running pace & speed","running pace & speed calculator","pace calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "calorie-calculator",
    enSlug: "calorie-calculator",
    name: "Calculateur de Daily Calorie & BMR",
    tagline: "Calculateur de Daily Calorie & BMR gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Daily Calorie & BMR. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Santé et Fitness",
    icon: "Flame",
    featured: true,
    keywords: ["calculateur de daily calorie & bmr","daily calorie & bmr calculator","calorie calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "water-intake-calculator",
    enSlug: "water-intake-calculator",
    name: "Calculateur de Daily Water Intake",
    tagline: "Calculateur de Daily Water Intake gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Daily Water Intake. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Santé et Fitness",
    icon: "Droplets",
    featured: true,
    keywords: ["calculateur de daily water intake","daily water intake calculator","water intake calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "body-fat-calculator",
    enSlug: "body-fat-calculator",
    name: "Calculateur de Body Fat Percentage",
    tagline: "Calculateur de Body Fat Percentage gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Body Fat Percentage. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Santé et Fitness",
    icon: "Activity",
    featured: true,
    keywords: ["calculateur de body fat percentage","body fat percentage calculator","body fat calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "velocity-acceleration-calculator",
    enSlug: "velocity-acceleration-calculator",
    name: "Calculateur de Speed, Velocity & Acceleration",
    tagline: "Calculateur de Speed, Velocity & Acceleration gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Speed, Velocity & Acceleration. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Unités et Physique",
    icon: "Zap",
    featured: true,
    keywords: ["calculateur de speed, velocity & acceleration","speed, velocity & acceleration calculator","velocity acceleration calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "density-calculator",
    enSlug: "density-calculator",
    name: "Calculateur de Density, Mass & Volume",
    tagline: "Calculateur de Density, Mass & Volume gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Density, Mass & Volume. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Unités et Physique",
    icon: "Box",
    featured: true,
    keywords: ["calculateur de density, mass & volume","density, mass & volume calculator","density calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "gpa-to-letter-calculator",
    enSlug: "gpa-to-letter-calculator",
    name: "Convertisseur de Percentage to Letter Grade",
    tagline: "Convertisseur de Percentage to Letter Grade gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Convertisseur de Percentage to Letter Grade. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Notes et Éducation",
    icon: "CheckCircle2",
    featured: true,
    keywords: ["convertisseur de percentage to letter grade","percentage to letter grade converter","gpa to letter calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "ideal-weight-calculator",
    enSlug: "ideal-weight-calculator",
    name: "Calculateur de Ideal Body Weight (IBW)",
    tagline: "Calculateur de Ideal Body Weight (IBW) gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Ideal Body Weight (IBW). Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Santé et Fitness",
    icon: "Heart",
    featured: true,
    keywords: ["calculateur de ideal body weight (ibw)","ideal body weight (ibw) calculator","ideal weight calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "macro-calculator",
    enSlug: "macro-calculator",
    name: "Calculateur de Macronutrient Ratio",
    tagline: "Calculateur de Macronutrient Ratio gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Macronutrient Ratio. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Santé et Fitness",
    icon: "Apple",
    featured: true,
    keywords: ["calculateur de macronutrient ratio","macronutrient ratio calculator","macro calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "weight-loss-calculator",
    enSlug: "weight-loss-calculator",
    name: "Calculateur de Weight Loss & Target Date Planner",
    tagline: "Calculateur de Weight Loss & Target Date Planner gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Weight Loss & Target Date Planner. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Santé et Fitness",
    icon: "TrendingDown",
    featured: true,
    keywords: ["calculateur de weight loss & target date planner","weight loss calculator & target date planner","weight loss calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "height-calculator",
    enSlug: "height-calculator",
    name: "Calculateur de Child & Adult Height Predictor",
    tagline: "Calculateur de Child & Adult Height Predictor gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Child & Adult Height Predictor. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Santé et Fitness",
    icon: "Ruler",
    featured: true,
    keywords: ["calculateur de child & adult height predictor","child & adult height predictor calculator","height calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "height-comparison-calculator",
    enSlug: "height-comparison-calculator",
    name: "Calculateur de Height Comparison (Side by Side)",
    tagline: "Calculateur de Height Comparison (Side by Side) gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Height Comparison (Side by Side). Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Santé et Fitness",
    icon: "Ruler",
    featured: true,
    keywords: ["calculateur de height comparison (side by side)","height comparison calculator (side by side)","height comparison calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "army-body-fat-calculator",
    enSlug: "army-body-fat-calculator",
    name: "Calculateur de US Army Body Fat",
    tagline: "Calculateur de US Army Body Fat gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de US Army Body Fat. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Santé et Fitness",
    icon: "ShieldCheck",
    featured: true,
    keywords: ["calculateur de us army body fat","us army body fat calculator","army body fat calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "keto-calculator",
    enSlug: "keto-calculator",
    name: "Calculateur de Keto Macro & Net Carb",
    tagline: "Calculateur de Keto Macro & Net Carb gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Keto Macro & Net Carb. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Santé et Fitness",
    icon: "Flame",
    featured: true,
    keywords: ["calculateur de keto macro & net carb","keto macro & net carb calculator","keto calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "height-percentile-calculator",
    enSlug: "height-percentile-calculator",
    name: "Calculateur de Height Percentile (CDC & WHO)",
    tagline: "Calculateur de Height Percentile (CDC & WHO) gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Height Percentile (CDC & WHO). Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Santé et Fitness",
    icon: "BarChart2",
    featured: true,
    keywords: ["calculateur de height percentile (cdc & who)","height percentile calculator (cdc & who)","height percentile calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "body-surface-area-calculator",
    enSlug: "body-surface-area-calculator",
    name: "Calculateur de Body Surface Area (BSA)",
    tagline: "Calculateur de Body Surface Area (BSA) gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Body Surface Area (BSA). Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Santé et Fitness",
    icon: "Square",
    featured: true,
    keywords: ["calculateur de body surface area (bsa)","body surface area (bsa) calculator","body surface area calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "total-body-water-calculator",
    enSlug: "total-body-water-calculator",
    name: "Calculateur de Total Body Water (TBW)",
    tagline: "Calculateur de Total Body Water (TBW) gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Total Body Water (TBW). Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Santé et Fitness",
    icon: "Droplet",
    featured: true,
    keywords: ["calculateur de total body water (tbw)","total body water (tbw) calculator","total body water calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "healthy-weight-calculator",
    enSlug: "healthy-weight-calculator",
    name: "Calculateur de Healthy Weight & Range Finder",
    tagline: "Calculateur de Healthy Weight & Range Finder gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Healthy Weight & Range Finder. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Santé et Fitness",
    icon: "Activity",
    featured: true,
    keywords: ["calculateur de healthy weight & range finder","healthy weight calculator & range finder","healthy weight calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "ohms-law-calculator",
    enSlug: "ohms-law-calculator",
    name: "Calculateur de Ohm's Law & Power",
    tagline: "Calculateur de Ohm's Law & Power gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Ohm's Law & Power. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Unités et Physique",
    icon: "Cpu",
    featured: true,
    keywords: ["calculateur de ohm's law & power","ohm's law & power calculator","ohms law calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "convert-temperature-calculator",
    enSlug: "convert-temperature-calculator",
    name: "Calculateur de Temperature",
    tagline: "Calculateur de Temperature gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Temperature. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Unités et Physique",
    icon: "Thermometer",
    featured: true,
    keywords: ["calculateur de temperature","temperature converter calculator","convert temperature calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "simple-interest-calculator",
    enSlug: "simple-interest-calculator",
    name: "Calculateur de Simple Interest Loan & Savings",
    tagline: "Calculateur de Simple Interest Loan & Savings gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Simple Interest Loan & Savings. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Finance et Quotidien",
    icon: "Coins",
    featured: true,
    keywords: ["calculateur de simple interest loan & savings","simple interest loan & savings calculator","simple interest calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "percentage-error-calculator",
    enSlug: "percentage-error-calculator",
    name: "Calculateur de Percentage Error",
    tagline: "Calculateur de Percentage Error gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Percentage Error. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Mathématiques et Algèbre",
    icon: "Percent",
    featured: true,
    keywords: ["calculateur de percentage error","percentage error calculator","percentage error calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "length-converter-calculator",
    enSlug: "length-converter-calculator",
    name: "Convertisseur de Length & Distance",
    tagline: "Convertisseur de Length & Distance gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Convertisseur de Length & Distance. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Conversion et Géométrie",
    icon: "Ruler",
    featured: true,
    keywords: ["convertisseur de length & distance","length & distance converter","length converter calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "area-calculator",
    enSlug: "area-calculator",
    name: "Calculateur de 2D Surface Area",
    tagline: "Calculateur de 2D Surface Area gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de 2D Surface Area. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Conversion et Géométrie",
    icon: "Shapes",
    featured: true,
    keywords: ["calculateur de 2d surface area","2d surface area calculator","area calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "volume-3d-calculator",
    enSlug: "volume-3d-calculator",
    name: "Calculateur de 3D Volume",
    tagline: "Calculateur de 3D Volume gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de 3D Volume. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Conversion et Géométrie",
    icon: "BoxSelect",
    featured: true,
    keywords: ["calculateur de 3d volume","3d volume calculator","volume 3d calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "scientific-calculator",
    enSlug: "scientific-calculator",
    name: "Calculateur de Scientific Function",
    tagline: "Calculateur de Scientific Function gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Scientific Function. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Mathématiques et Algèbre",
    icon: "Calculator",
    featured: true,
    keywords: ["calculateur de scientific function","scientific function calculator","scientific calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "exponent-calculator",
    enSlug: "exponent-calculator",
    name: "Calculateur de Exponent & Power",
    tagline: "Calculateur de Exponent & Power gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Exponent & Power. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Mathématiques et Algèbre",
    icon: "Superscript",
    featured: true,
    keywords: ["calculateur de exponent & power","exponent & power calculator","exponent calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "gpa-to-4-scale-calculator",
    enSlug: "gpa-to-4-scale-calculator",
    name: "Convertisseur de Marks & 5-Point to 4.0 GPA",
    tagline: "Convertisseur de Marks & 5-Point to 4.0 GPA gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Convertisseur de Marks & 5-Point to 4.0 GPA. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Notes et Éducation",
    icon: "Award",
    featured: true,
    keywords: ["convertisseur de marks & 5-point to 4.0 gpa","marks & 5-point to 4.0 gpa converter","gpa to 4 scale calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "standard-deviation-calculator",
    enSlug: "standard-deviation-calculator",
    name: "Calculateur de Standard Deviation & Variance",
    tagline: "Calculateur de Standard Deviation & Variance gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Standard Deviation & Variance. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Statistiques et Données",
    icon: "BarChart2",
    featured: true,
    keywords: ["calculateur de standard deviation & variance","standard deviation & variance calculator","standard deviation calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "probability-calculator",
    enSlug: "probability-calculator",
    name: "Calculateur de Probability & Odds",
    tagline: "Calculateur de Probability & Odds gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Probability & Odds. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Statistiques et Données",
    icon: "PieChart",
    featured: true,
    keywords: ["calculateur de probability & odds","probability & odds calculator","probability calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "npr-ncr-calculator",
    enSlug: "npr-ncr-calculator",
    name: "Calculateur de Permutation & Combination (nPr / nCr)",
    tagline: "Calculateur de Permutation & Combination (nPr / nCr) gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Permutation & Combination (nPr / nCr). Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Statistiques et Données",
    icon: "Binary",
    featured: true,
    keywords: ["calculateur de permutation & combination (npr / ncr)","permutation & combination (npr / ncr) calculator","npr ncr calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "resistor-color-code-calculator",
    enSlug: "resistor-color-code-calculator",
    name: "Calculateur de Resistor Color Code",
    tagline: "Calculateur de Resistor Color Code gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Resistor Color Code. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Ingénierie et Électronique",
    icon: "Cpu",
    featured: true,
    keywords: ["calculateur de resistor color code","resistor color code calculator","resistor color code calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "voltage-drop-calculator",
    enSlug: "voltage-drop-calculator",
    name: "Calculateur de Wire Voltage Drop & Size",
    tagline: "Calculateur de Wire Voltage Drop & Size gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Wire Voltage Drop & Size. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Ingénierie et Électronique",
    icon: "Zap",
    featured: true,
    keywords: ["calculateur de wire voltage drop & size","wire voltage drop & size calculator","voltage drop calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "power-factor-calculator",
    enSlug: "power-factor-calculator",
    name: "Calculateur de Power Factor (PF) & kVAR Correction",
    tagline: "Calculateur de Power Factor (PF) & kVAR Correction gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Power Factor (PF) & kVAR Correction. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Ingénierie et Électronique",
    icon: "Activity",
    featured: true,
    keywords: ["calculateur de power factor (pf) & kvar correction","power factor (pf) & kvar correction calculator","power factor calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "molarity-calculator",
    enSlug: "molarity-calculator",
    name: "Calculateur de Molarity & Solution Concentration",
    tagline: "Calculateur de Molarity & Solution Concentration gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Molarity & Solution Concentration. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Chimie et Science",
    icon: "FlaskConical",
    featured: true,
    keywords: ["calculateur de molarity & solution concentration","molarity & solution concentration calculator","molarity calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "ph-calculator",
    enSlug: "ph-calculator",
    name: "Calculateur de pH, pOH & Hydrogen Ion [H+]",
    tagline: "Calculateur de pH, pOH & Hydrogen Ion [H+] gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de pH, pOH & Hydrogen Ion [H+]. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Chimie et Science",
    icon: "TestTube",
    featured: true,
    keywords: ["calculateur de ph, poh & hydrogen ion [h+]","ph, poh & hydrogen ion [h+] calculator","ph calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "ideal-gas-law-calculator",
    enSlug: "ideal-gas-law-calculator",
    name: "Calculateur de Ideal Gas Law (PV = nRT)",
    tagline: "Calculateur de Ideal Gas Law (PV = nRT) gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Ideal Gas Law (PV = nRT). Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Chimie et Science",
    icon: "Flame",
    featured: true,
    keywords: ["calculateur de ideal gas law (pv = nrt)","ideal gas law (pv = nrt) calculator","ideal gas law calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "roi-calculator",
    enSlug: "roi-calculator",
    name: "Calculateur de ROI (Return on Investment)",
    tagline: "Calculateur de ROI (Return on Investment) gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de ROI (Return on Investment). Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Affaires et Productivité",
    icon: "TrendingUp",
    featured: true,
    keywords: ["calculateur de roi (return on investment)","roi (return on investment) calculator","roi calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "cpm-calculator",
    enSlug: "cpm-calculator",
    name: "Calculateur de CPM (Cost Per Mille / Thousand)",
    tagline: "Calculateur de CPM (Cost Per Mille / Thousand) gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de CPM (Cost Per Mille / Thousand). Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Affaires et Productivité",
    icon: "Target",
    featured: true,
    keywords: ["calculateur de cpm (cost per mille / thousand)","cpm (cost per mille / thousand) calculator","cpm calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "breakeven-calculator",
    enSlug: "breakeven-calculator",
    name: "Calculateur de Breakeven Point & Profit Margin",
    tagline: "Calculateur de Breakeven Point & Profit Margin gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Breakeven Point & Profit Margin. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Affaires et Productivité",
    icon: "DollarSign",
    featured: true,
    keywords: ["calculateur de breakeven point & profit margin","breakeven point & profit margin calculator","breakeven calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "mortgage-calculator",
    enSlug: "mortgage-calculator",
    name: "Calculateur de Mortgage & Loan Amortization",
    tagline: "Calculateur de Mortgage & Loan Amortization gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Mortgage & Loan Amortization. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Finance et Quotidien",
    icon: "Home",
    featured: true,
    keywords: ["calculateur de mortgage & loan amortization","mortgage & loan amortization calculator","mortgage calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "compound-interest-calculator",
    enSlug: "compound-interest-calculator",
    name: "Calculateur de Compound Interest & Savings Growth",
    tagline: "Calculateur de Compound Interest & Savings Growth gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Compound Interest & Savings Growth. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Finance et Quotidien",
    icon: "TrendingUp",
    featured: true,
    keywords: ["calculateur de compound interest & savings growth","compound interest & savings growth calculator","compound interest calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "tdee-calculator",
    enSlug: "tdee-calculator",
    name: "Calculateur de TDEE & BMR Calorie",
    tagline: "Calculateur de TDEE & BMR Calorie gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de TDEE & BMR Calorie. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Santé et Fitness",
    icon: "Flame",
    featured: true,
    keywords: ["calculateur de tdee & bmr calorie","tdee & bmr calorie calculator","tdee calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "inflation-calculator",
    enSlug: "inflation-calculator",
    name: "Calculateur de Inflation & Purchasing Power",
    tagline: "Calculateur de Inflation & Purchasing Power gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Inflation & Purchasing Power. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Finance et Quotidien",
    icon: "ArrowDownRight",
    featured: true,
    keywords: ["calculateur de inflation & purchasing power","inflation & purchasing power calculator","inflation calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "linear-equations-calculator",
    enSlug: "linear-equations-calculator",
    name: "Solveur de System of Linear Equations",
    tagline: "Solveur de System of Linear Equations gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Solveur de System of Linear Equations. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Mathématiques et Algèbre",
    icon: "Binary",
    featured: true,
    keywords: ["solveur de system of linear equations","system of linear equations solver","linear equations calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "vector-calculator",
    enSlug: "vector-calculator",
    name: "Calculateur de 2D & 3D Vector Math",
    tagline: "Calculateur de 2D & 3D Vector Math gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de 2D & 3D Vector Math. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Unités et Physique",
    icon: "Compass",
    featured: true,
    keywords: ["calculateur de 2d & 3d vector math","2d & 3d vector math calculator","vector calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "auto-loan-calculator",
    enSlug: "auto-loan-calculator",
    name: "Calculateur de Auto Loan & Car Payment",
    tagline: "Calculateur de Auto Loan & Car Payment gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Auto Loan & Car Payment. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Finance et Quotidien",
    icon: "Car",
    featured: true,
    keywords: ["calculateur de auto loan & car payment","auto loan & car payment calculator","auto loan calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "macro-ratio-calculator",
    enSlug: "macro-ratio-calculator",
    name: "Calculateur de Macronutrient & Meal Ratio",
    tagline: "Calculateur de Macronutrient & Meal Ratio gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Macronutrient & Meal Ratio. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Santé et Fitness",
    icon: "Utensils",
    featured: true,
    keywords: ["calculateur de macronutrient & meal ratio","macronutrient & meal ratio calculator","macro ratio calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "percentage-change-calculator",
    enSlug: "percentage-change-calculator",
    name: "Calculateur de Percentage Change & Difference",
    tagline: "Calculateur de Percentage Change & Difference gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Percentage Change & Difference. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Mathématiques et Algèbre",
    icon: "Percent",
    featured: true,
    keywords: ["calculateur de percentage change & difference","percentage change & difference calculator","percentage change calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "fire-calculator",
    enSlug: "fire-calculator",
    name: "Calculateur de FIRE & Retirement Nest Egg",
    tagline: "Calculateur de FIRE & Retirement Nest Egg gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de FIRE & Retirement Nest Egg. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Finance et Quotidien",
    icon: "Flame",
    featured: true,
    keywords: ["calculateur de fire & retirement nest egg","fire & retirement nest egg calculator","fire calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "loan-payoff-calculator",
    enSlug: "loan-payoff-calculator",
    name: "Calculateur de Loan Payoff & Extra Payment",
    tagline: "Calculateur de Loan Payoff & Extra Payment gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Loan Payoff & Extra Payment. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Finance et Quotidien",
    icon: "Sparkles",
    featured: true,
    keywords: ["calculateur de loan payoff & extra payment","loan payoff & extra payment calculator","loan payoff calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "kinetic-energy-calculator",
    enSlug: "kinetic-energy-calculator",
    name: "Calculateur de Kinetic Energy & Momentum Physics",
    tagline: "Calculateur de Kinetic Energy & Momentum Physics gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Kinetic Energy & Momentum Physics. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Unités et Physique",
    icon: "Zap",
    featured: true,
    keywords: ["calculateur de kinetic energy & momentum physics","kinetic energy & momentum physics calculator","kinetic energy calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "sales-tax-calculator",
    enSlug: "sales-tax-calculator",
    name: "Calculateur de Sales Tax & Reverse Tax",
    tagline: "Calculateur de Sales Tax & Reverse Tax gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Sales Tax & Reverse Tax. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Finance et Quotidien",
    icon: "Tag",
    featured: true,
    keywords: ["calculateur de sales tax & reverse tax","sales tax & reverse tax calculator","sales tax calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "restaurant-tip-calculator",
    enSlug: "restaurant-tip-calculator",
    name: "Calculateur de Restaurant Tip & Bill Splitter",
    tagline: "Calculateur de Restaurant Tip & Bill Splitter gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Restaurant Tip & Bill Splitter. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Finance et Quotidien",
    icon: "Utensils",
    featured: true,
    keywords: ["calculateur de restaurant tip & bill splitter","restaurant tip & bill splitter calculator","restaurant tip calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "gpa-conversion-calculator",
    enSlug: "gpa-conversion-calculator",
    name: "Calculateur de GPA, CGPA & 10-Point Scale Conversion",
    tagline: "Calculateur de GPA, CGPA & 10-Point Scale Conversion gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de GPA, CGPA & 10-Point Scale Conversion. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Notes et Éducation",
    icon: "Award",
    featured: true,
    keywords: ["calculateur de gpa, cgpa & 10-point scale conversion","gpa, cgpa & 10-point scale conversion calculator","gpa conversion calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "calorie-deficit-calculator",
    enSlug: "calorie-deficit-calculator",
    name: "Calculateur de Calorie Deficit & Weight Loss Target Date",
    tagline: "Calculateur de Calorie Deficit & Weight Loss Target Date gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Calorie Deficit & Weight Loss Target Date. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Santé et Fitness",
    icon: "Target",
    featured: true,
    keywords: ["calculateur de calorie deficit & weight loss target date","calorie deficit & weight loss target date calculator","calorie deficit calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "quadratic-solver-calculator",
    enSlug: "quadratic-solver-calculator",
    name: "Solveur de Quadratic Equation & Parabola Vertex",
    tagline: "Solveur de Quadratic Equation & Parabola Vertex gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Solveur de Quadratic Equation & Parabola Vertex. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Mathématiques et Algèbre",
    icon: "Binary",
    featured: true,
    keywords: ["solveur de quadratic equation & parabola vertex","quadratic equation & parabola vertex solver","quadratic solver calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "work-power-calculator",
    enSlug: "work-power-calculator",
    name: "Calculateur de Work, Power & Horsepower Physics",
    tagline: "Calculateur de Work, Power & Horsepower Physics gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Work, Power & Horsepower Physics. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Unités et Physique",
    icon: "Zap",
    featured: true,
    keywords: ["calculateur de work, power & horsepower physics","work, power & horsepower physics calculator","work power calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "mortgage-refinance-calculator",
    enSlug: "mortgage-refinance-calculator",
    name: "Calculateur de Mortgage Refinance & Break-Even",
    tagline: "Calculateur de Mortgage Refinance & Break-Even gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Mortgage Refinance & Break-Even. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Finance et Quotidien",
    icon: "RefreshCw",
    featured: true,
    keywords: ["calculateur de mortgage refinance & break-even","mortgage refinance & break-even calculator","mortgage refinance calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "ideal-body-weight-calculator",
    enSlug: "ideal-body-weight-calculator",
    name: "Calculateur de Ideal Body Weight (IBW)",
    tagline: "Calculateur de Ideal Body Weight (IBW) gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Ideal Body Weight (IBW). Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Santé et Fitness",
    icon: "HeartPulse",
    featured: true,
    keywords: ["calculateur de ideal body weight (ibw)","ideal body weight (ibw) calculator","ideal body weight calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "fraction-arithmetic-calculator",
    enSlug: "fraction-arithmetic-calculator",
    name: "Calculateur de Fraction & Mixed Number Arithmetic",
    tagline: "Calculateur de Fraction & Mixed Number Arithmetic gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Fraction & Mixed Number Arithmetic. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Mathématiques et Algèbre",
    icon: "Binary",
    featured: true,
    keywords: ["calculateur de fraction & mixed number arithmetic","fraction & mixed number arithmetic calculator","fraction arithmetic calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "cagr-calculator",
    enSlug: "cagr-calculator",
    name: "Calculateur de Compound Annual Growth Rate (CAGR)",
    tagline: "Calculateur de Compound Annual Growth Rate (CAGR) gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Compound Annual Growth Rate (CAGR). Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Affaires et Productivité",
    icon: "TrendingUp",
    featured: true,
    keywords: ["calculateur de compound annual growth rate (cagr)","compound annual growth rate (cagr) calculator","cagr calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "wave-speed-calculator",
    enSlug: "wave-speed-calculator",
    name: "Calculateur de Wavelength, Frequency & Wave Speed Physics",
    tagline: "Calculateur de Wavelength, Frequency & Wave Speed Physics gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Wavelength, Frequency & Wave Speed Physics. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Unités et Physique",
    icon: "Activity",
    featured: true,
    keywords: ["calculateur de wavelength, frequency & wave speed physics","wavelength, frequency & wave speed physics calculator","wave speed calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "dti-calculator",
    enSlug: "dti-calculator",
    name: "Calculateur de Debt-to-Income (DTI) Ratio",
    tagline: "Calculateur de Debt-to-Income (DTI) Ratio gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Debt-to-Income (DTI) Ratio. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Finance et Quotidien",
    icon: "ShieldCheck",
    featured: true,
    keywords: ["calculateur de debt-to-income (dti) ratio","debt-to-income (dti) ratio calculator","dti calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "paycheck-calculator",
    enSlug: "paycheck-calculator",
    name: "Calculateur de Paycheck & Take-Home Pay",
    tagline: "Calculateur de Paycheck & Take-Home Pay gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Paycheck & Take-Home Pay. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Finance et Quotidien",
    icon: "Wallet",
    featured: true,
    keywords: ["calculateur de paycheck & take-home pay","paycheck & take-home pay calculator","paycheck calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "water-retention-calculator",
    enSlug: "water-retention-calculator",
    name: "Calculateur de Water Weight & Fluid Retention",
    tagline: "Calculateur de Water Weight & Fluid Retention gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Water Weight & Fluid Retention. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Santé et Fitness",
    icon: "Droplets",
    featured: true,
    keywords: ["calculateur de water weight & fluid retention","water weight & fluid retention calculator","water retention calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "polynomial-calculator",
    enSlug: "polynomial-calculator",
    name: "Calculateur de Polynomial & Synthetic Division",
    tagline: "Calculateur de Polynomial & Synthetic Division gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Polynomial & Synthetic Division. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Mathématiques et Algèbre",
    icon: "Binary",
    featured: true,
    keywords: ["calculateur de polynomial & synthetic division","polynomial solver & synthetic division calculator","polynomial calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "car-depreciation-calculator",
    enSlug: "car-depreciation-calculator",
    name: "Calculateur de Car Depreciation & Resale Value",
    tagline: "Calculateur de Car Depreciation & Resale Value gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Car Depreciation & Resale Value. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Finance et Quotidien",
    icon: "Car",
    featured: true,
    keywords: ["calculateur de car depreciation & resale value","car depreciation & resale value calculator","car depreciation calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "weighted-gpa-calculator",
    enSlug: "weighted-gpa-calculator",
    name: "Calculateur de Weighted vs Unweighted GPA",
    tagline: "Calculateur de Weighted vs Unweighted GPA gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Weighted vs Unweighted GPA. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Notes et Éducation",
    icon: "GraduationCap",
    featured: true,
    keywords: ["calculateur de weighted vs unweighted gpa","weighted vs unweighted gpa calculator","weighted gpa calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "torque-calculator",
    enSlug: "torque-calculator",
    name: "Calculateur de Torque & Rotational Dynamics Physics",
    tagline: "Calculateur de Torque & Rotational Dynamics Physics gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Torque & Rotational Dynamics Physics. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Unités et Physique",
    icon: "RotateCw",
    featured: true,
    keywords: ["calculateur de torque & rotational dynamics physics","torque & rotational dynamics physics calculator","torque calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "half-life-calculator",
    enSlug: "half-life-calculator",
    name: "Calculateur de Radioactive Half-Life & Decay",
    tagline: "Calculateur de Radioactive Half-Life & Decay gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Radioactive Half-Life & Decay. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Chimie et Science",
    icon: "Atom",
    featured: true,
    keywords: ["calculateur de radioactive half-life & decay","radioactive half-life & decay calculator","half life calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "amortization-schedule-calculator",
    enSlug: "amortization-schedule-calculator",
    name: "Calculateur de Loan & Mortgage Amortization Schedule",
    tagline: "Calculateur de Loan & Mortgage Amortization Schedule gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Loan & Mortgage Amortization Schedule. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Finance et Quotidien",
    icon: "Table",
    featured: true,
    keywords: ["calculateur de loan & mortgage amortization schedule","loan & mortgage amortization schedule calculator","amortization schedule calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "bmi-percentile-calculator",
    enSlug: "bmi-percentile-calculator",
    name: "Calculateur de Child & Teen BMI Percentile (CDC & WHO)",
    tagline: "Calculateur de Child & Teen BMI Percentile (CDC & WHO) gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Child & Teen BMI Percentile (CDC & WHO). Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Santé et Fitness",
    icon: "HeartPulse",
    featured: true,
    keywords: ["calculateur de child & teen bmi percentile (cdc & who)","child & teen bmi percentile calculator (cdc & who)","bmi percentile calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "matrix-determinant-calculator",
    enSlug: "matrix-determinant-calculator",
    name: "Calculateur de Matrix Determinant & Transpose",
    tagline: "Calculateur de Matrix Determinant & Transpose gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Matrix Determinant & Transpose. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Mathématiques et Algèbre",
    icon: "Grid",
    featured: true,
    keywords: ["calculateur de matrix determinant & transpose","matrix determinant & transpose calculator","matrix determinant calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "calories-burned-calculator",
    enSlug: "calories-burned-calculator",
    name: "Calculateur de Exercise Calories Burned & MET",
    tagline: "Calculateur de Exercise Calories Burned & MET gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Exercise Calories Burned & MET. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Santé et Fitness",
    icon: "Flame",
    featured: true,
    keywords: ["calculateur de exercise calories burned & met","exercise calories burned & met calculator","calories burned calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "electricity-cost-calculator",
    enSlug: "electricity-cost-calculator",
    name: "Calculateur de Appliance Electricity & Power Cost",
    tagline: "Calculateur de Appliance Electricity & Power Cost gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Appliance Electricity & Power Cost. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Finance et Quotidien",
    icon: "Zap",
    featured: true,
    keywords: ["calculateur de appliance electricity & power cost","appliance electricity & power cost calculator","electricity cost calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "dilution-calculator",
    enSlug: "dilution-calculator",
    name: "Calculateur de Solution Dilution (C₁V₁ = C₂V₂)",
    tagline: "Calculateur de Solution Dilution (C₁V₁ = C₂V₂) gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Solution Dilution (C₁V₁ = C₂V₂). Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Chimie et Science",
    icon: "FlaskConical",
    featured: true,
    keywords: ["calculateur de solution dilution (c₁v₁ = c₂v₂)","solution dilution calculator (c₁v₁ = c₂v₂)","dilution calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "rc-circuit-calculator",
    enSlug: "rc-circuit-calculator",
    name: "Calculateur de RC Circuit Time Constant (τ = R·C)",
    tagline: "Calculateur de RC Circuit Time Constant (τ = R·C) gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de RC Circuit Time Constant (τ = R·C). Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Ingénierie et Électronique",
    icon: "Cpu",
    featured: true,
    keywords: ["calculateur de rc circuit time constant (τ = r·c)","rc circuit time constant (τ = r·c) calculator","rc circuit calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "gpa-semester-calculator",
    enSlug: "gpa-semester-calculator",
    name: "Calculateur de Semester & Term GPA",
    tagline: "Calculateur de Semester & Term GPA gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Semester & Term GPA. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Notes et Éducation",
    icon: "GraduationCap",
    featured: true,
    keywords: ["calculateur de semester & term gpa","semester & term gpa calculator","gpa semester calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "stoichiometry-calculator",
    enSlug: "stoichiometry-calculator",
    name: "Calculateur de Stoichiometry & Theoretical Yield",
    tagline: "Calculateur de Stoichiometry & Theoretical Yield gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Stoichiometry & Theoretical Yield. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Chimie et Science",
    icon: "FlaskConical",
    featured: true,
    keywords: ["calculateur de stoichiometry & theoretical yield","stoichiometry & theoretical yield calculator","stoichiometry calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "logic-gate-calculator",
    enSlug: "logic-gate-calculator",
    name: "Calculateur de Boolean Logic Gate & Truth Table Generator",
    tagline: "Calculateur de Boolean Logic Gate & Truth Table Generator gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Boolean Logic Gate & Truth Table Generator. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Ingénierie et Électronique",
    icon: "Cpu",
    featured: true,
    keywords: ["calculateur de boolean logic gate & truth table generator","boolean logic gate & truth table generator","logic gate calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "ellipse-calculator",
    enSlug: "ellipse-calculator",
    name: "Calculateur de Ellipse Area, Perimeter & Foci",
    tagline: "Calculateur de Ellipse Area, Perimeter & Foci gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Ellipse Area, Perimeter & Foci. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Conversion et Géométrie",
    icon: "Shapes",
    featured: true,
    keywords: ["calculateur de ellipse area, perimeter & foci","ellipse area, perimeter & foci calculator","ellipse calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "buffer-ph-calculator",
    enSlug: "buffer-ph-calculator",
    name: "Calculateur de Henderson-Hasselbalch Buffer pH",
    tagline: "Calculateur de Henderson-Hasselbalch Buffer pH gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Henderson-Hasselbalch Buffer pH. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Chimie et Science",
    icon: "TestTube",
    featured: true,
    keywords: ["calculateur de henderson-hasselbalch buffer ph","henderson-hasselbalch buffer ph calculator","buffer ph calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "led-resistor-calculator",
    enSlug: "led-resistor-calculator",
    name: "Calculateur de LED Series Current Limiting Resistor",
    tagline: "Calculateur de LED Series Current Limiting Resistor gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de LED Series Current Limiting Resistor. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Ingénierie et Électronique",
    icon: "Zap",
    featured: true,
    keywords: ["calculateur de led series current limiting resistor","led series current limiting resistor calculator","led resistor calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "gpa-raise-calculator",
    enSlug: "gpa-raise-calculator",
    name: "Calculateur de GPA Raising & Target Goal",
    tagline: "Calculateur de GPA Raising & Target Goal gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de GPA Raising & Target Goal. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Notes et Éducation",
    icon: "Target",
    featured: true,
    keywords: ["calculateur de gpa raising & target goal","gpa raising & target goal calculator","gpa raise calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "polynomial-roots-calculator",
    enSlug: "polynomial-roots-calculator",
    name: "Calculateur de Polynomial Roots & Quadratic/Cubic Factoring",
    tagline: "Calculateur de Polynomial Roots & Quadratic/Cubic Factoring gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Polynomial Roots & Quadratic/Cubic Factoring. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Mathématiques et Algèbre",
    icon: "Binary",
    featured: true,
    keywords: ["calculateur de polynomial roots & quadratic/cubic factoring","polynomial roots & quadratic/cubic factoring calculator","polynomial roots calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "decibel-calculator",
    enSlug: "decibel-calculator",
    name: "Calculateur de Decibel (dB) Sound & Power Gain",
    tagline: "Calculateur de Decibel (dB) Sound & Power Gain gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Decibel (dB) Sound & Power Gain. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Ingénierie et Électronique",
    icon: "Volume2",
    featured: true,
    keywords: ["calculateur de decibel (db) sound & power gain","decibel (db) sound & power gain calculator","decibel calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "empirical-formula-calculator",
    enSlug: "empirical-formula-calculator",
    name: "Calculateur de Empirical & Molecular Formula Chemistry",
    tagline: "Calculateur de Empirical & Molecular Formula Chemistry gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Empirical & Molecular Formula Chemistry. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Chimie et Science",
    icon: "FlaskConical",
    featured: true,
    keywords: ["calculateur de empirical & molecular formula chemistry","empirical & molecular formula chemistry calculator","empirical formula calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "customer-lifetime-value-calculator",
    enSlug: "customer-lifetime-value-calculator",
    name: "Calculateur de Customer Lifetime Value (LTV / CLV)",
    tagline: "Calculateur de Customer Lifetime Value (LTV / CLV) gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Customer Lifetime Value (LTV / CLV). Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Affaires et Productivité",
    icon: "Users",
    featured: true,
    keywords: ["calculateur de customer lifetime value (ltv / clv)","customer lifetime value (ltv / clv) calculator","customer lifetime value calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "freelance-hourly-rate-calculator",
    enSlug: "freelance-hourly-rate-calculator",
    name: "Calculateur de Freelance Hourly & Daily Rate",
    tagline: "Calculateur de Freelance Hourly & Daily Rate gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Freelance Hourly & Daily Rate. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Affaires et Productivité",
    icon: "Briefcase",
    featured: true,
    keywords: ["calculateur de freelance hourly & daily rate","freelance hourly & daily rate calculator","freelance hourly rate calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "employee-turnover-cost-calculator",
    enSlug: "employee-turnover-cost-calculator",
    name: "Calculateur de Employee Turnover & Replacement Cost",
    tagline: "Calculateur de Employee Turnover & Replacement Cost gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Employee Turnover & Replacement Cost. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Affaires et Productivité",
    icon: "UserMinus",
    featured: true,
    keywords: ["calculateur de employee turnover & replacement cost","employee turnover & replacement cost calculator","employee turnover cost calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "customer-acquisition-cost-calculator",
    enSlug: "customer-acquisition-cost-calculator",
    name: "Calculateur de Customer Acquisition Cost (CAC) & Payback",
    tagline: "Calculateur de Customer Acquisition Cost (CAC) & Payback gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Customer Acquisition Cost (CAC) & Payback. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Affaires et Productivité",
    icon: "Target",
    featured: true,
    keywords: ["calculateur de customer acquisition cost (cac) & payback","customer acquisition cost (cac) & payback calculator","customer acquisition cost calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "working-capital-calculator",
    enSlug: "working-capital-calculator",
    name: "Calculateur de Working Capital & Current Ratio",
    tagline: "Calculateur de Working Capital & Current Ratio gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Working Capital & Current Ratio. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Affaires et Productivité",
    icon: "Landmark",
    featured: true,
    keywords: ["calculateur de working capital & current ratio","working capital & current ratio calculator","working capital calculator","calculateur gratuit en ligne"],
  },
  {
    slug: "email-open-rate-click-through-calculator",
    enSlug: "email-open-rate-click-through-calculator",
    name: "Calculateur de Email Marketing Open Rate, CTR & Campaign ROI",
    tagline: "Calculateur de Email Marketing Open Rate, CTR & Campaign ROI gratuit en ligne. Calcul instantané avec formules et solutions étape par étape.",
    description: "Calculez facilement avec Calculateur de Email Marketing Open Rate, CTR & Campaign ROI. Outil gratuit en ligne sans inscription et respectueux de votre vie privée.",
    category: "Affaires et Productivité",
    icon: "Mail",
    featured: true,
    keywords: ["calculateur de email marketing open rate, ctr & campaign roi","email marketing open rate, ctr & campaign roi calculator","email open rate click through calculator","calculateur gratuit en ligne"],
  },
];

export function getFrCalculatorBySlug(slug: string): FrCalculatorMeta | undefined {
  return FR_CALCULATORS.find((c) => c.slug === slug || c.enSlug === slug);
}

export function getEnCalculatorSlugForFrSlug(frSlug: string): string {
  const found = FR_CALCULATORS.find((c) => c.slug === frSlug || c.enSlug === frSlug);
  return found ? found.enSlug : frSlug;
}

export function getFrCalculatorSlugForEnSlug(enSlug: string): string {
  const found = FR_CALCULATORS.find((c) => c.enSlug === enSlug || c.slug === enSlug);
  return found ? found.slug : enSlug;
}

export function relatedFrCalculators(currentSlug: string, count = 4): FrCalculatorMeta[] {
  const current = getFrCalculatorBySlug(currentSlug);
  return FR_CALCULATORS.filter((c) => c.slug !== current?.slug).slice(0, count);
}
